import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import theme from '../theme';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  onDownloadApp: () => void;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onClose,
  onDownloadApp,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.default,
        },
      }}
    >
      <DialogTitle>
        <Typography style={{ ...theme.typography.title1, color: 'white' }}>
          You are now a FOODIE!
        </Typography>
      </DialogTitle>
      <DialogContent style={{ ...theme.typography.body1, color: 'white' }}>
        Thank you for registering, and we are excited for you to make an impact
        with E2G FOOD. Explore the app, share with loved ones and feed the world
        more nutritiously. If you need assistance, don't hesitate to reach out
        at info@e2gfood.com. Together, we can alleviate global hunger and
        provide nutritious FOOD to communities worldwide.
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <Button
          onClick={onDownloadApp}
          color="primary"
          variant="contained"
          style={{
            margin: '10px',
            width: '85%',
            borderRadius: '20px',
            textTransform: 'none',
          }}
        >
          Download Mobile App
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
